export const TOGGLE_SIDE_BAR = "TOGGLE_SIDE_BAR";
export const BIG_SCREEN_STATUS_CHANGE = "BIG_SCREEN_STATUS_CHANGE";
export const USERNAME_CHANGED = "USERNAME_CHANGED";
export const LOGIN_STATUS_CHANGED = "LOGIN_STATUS_CHANGED";
export const TOKEN_CHANGED = "TOKEN_CHANGED";
export const USER_COLOR_CHANGED = "USER_COLOR_CHANGED";
export const USER_ID_CHANGED = "USER_ID_CHANGED";
export const SCREEN_WIDTH_CHANGED = "SCREEN_WIDTH_CHANGED";
export const ADMIN_STATUS_CHANGED = "ADMIN_STATUS_CHANGED";
export const USER_SHOPNAME_CHANGED = "USER_SHOPNAME_CHANGED";
